import React from "react";
import { ShieldCheck, Bot } from "lucide-react";

export default function Services(props) {
  function touchStarted(event) {
    const startY = event.touches[0].clientY;
    const services = document.getElementById("services");
    services.addEventListener("touchend", touchEnd);
    function touchEnd(event) {
      const endY = event.changedTouches[0].clientY;
      if (endY > startY + 200) {
        // props.swipeUp()
        return;
      } else if (endY < startY - 200) {
        // props.swipeDown()
        return;
      }
    }
  }

  return (
    <div id="services" className={props.className} onTouchStart={touchStarted}>
      <div className="sides">
        <div className="arrow left">
          <div className="head" onClick={props.gotoHome}></div>
        </div>
        <div className="arrow right">
          <div className="head" onClick={props.gotoPortfolio}></div>
        </div>
      </div>
      <div className="heading">
        <h1 className="title">{props.isFrench ? "Métier" : "Services."}</h1>
      </div>
      <div className="content">
        <div>
          <h2>
            {props.isFrench ? `Parlons` : `Let's talk`}
            <br />
            {props.isFrench ? `de votre projet` : `about your project`}
          </h2>
          <div className="gotocontact" onClick={props.gotoContact}>
            {props.isFrench ? "Connectez" : "Connect"}
          </div>
        </div>
        <div className="service">
          <div
            className="icon"
            style={{
              background: "#000",
              color: "gold",
            }}
          >
            <i className="fa-brands fa-bitcoin" />
          </div>
          <h3>{"Blockchain Dev."}</h3>
          {props.isFrench
            ? "Expert en développement dApps, smart contracts et Web3. Je crée des solutions blockchain sécurisées pour NFTs et DeFi."
            : "Expert in dApps, smart contracts and Web3 development. I build secure blockchain solutions for NFTs and DeFi."}
        </div>
        <div className="service">
          <div className="icon">
            <i className="fa-brands fa-html5" />
          </div>
          <h3>{props.isFrench ? "Développement Web" : "Web Development"}</h3>
          {props.isFrench
            ? "Je développe des applications Web complètes, en couvrant les aspects backend et frontend pour offrir une expérience utilisateur fluide et engageante."
            : "I develop complete Web applications, covering both backend and frontend aspects to deliver a seamless and engaging user experience."}
        </div>
        <div className="service">
          <div
            className="icon"
            style={{
              background: "#55c",
              color: "#fff",
            }}
          >
            <i className="fa-brands fa-react" />
          </div>
          <h3>
            {props.isFrench
              ? "Applications Mobile/PC"
              : "Mobile/PC App"}
          </h3>
          {props.isFrench
            ? "Création d'applications mobiles et desktop puissantes et évolutives pour iOS, Android et Windows, utilisant React Native, Flutter, Swift (iOS/macOS), Kotlin (Android) et Java/.NET (Windows)."
            : "Build powerful cross platform mobile and desktop applications for iOS, Android & Windows using React Native, Flutter, Swift (iOS/macOS), Kotlin (Android), and Java/.NET (Windows)."}
        </div>
        <div className="service">
          <div
            className="icon"
            style={{
              background: "#A259FF",
              color: "#fff",
            }}
          >
            <i className="fa-brands fa-figma" />
          </div>
          <h3>UI/UX</h3>
          {props.isFrench
            ? "Je conçois des interfaces utilisateur intuitives et des prototypes interactifs. Je crée des expériences numériques élégantes et fonctionnelles."
            : "I design intuitive user interfaces and interactive prototypes. I create elegant and functional digital experiences."}
        </div>
        <div className="service">
          <div
            className="icon"
            style={{
              background: "#00a8a8",
              color: "#fff",
            }}
          >
            {/* <Key size={24} /> */}
            <ShieldCheck size={24} />
          </div>
          <h3>{props.isFrench ? "Cybersécurité" : "Cybersecurity"}</h3>
          {props.isFrench
            ? "Protection de vos systèmes et données contre les menaces numériques. Audit de sécurité, tests de pénétration et implémentation de mesures de protection robustes."
            : "Protecting your systems and data from digital threats. Security audits, penetration testing, and implementation of robust protective measures."}
        </div>
        <div className="service">
          <div
            className="icon"
            style={{
              background: "#000",
              color: "#fff",
            }}
          >
            <Bot size={24} />
          </div>
          <h3>{props.isFrench ? "IA/Automatisation" : "AI/Automation"}</h3>
          {props.isFrench
            ? "Je développe des solutions d'intelligence artificielle et d'automatisation pour optimiser vos processus. Intégration de modèles ML, chatbots intelligents et systèmes automatisés."
            : "I develop AI and automation solutions to optimize your processes. ML model integration, intelligent chatbots, and automated systems."}
        </div>
      </div>
    </div>
  );
}
